<template>
  <div class="double11-wrap">
    <app-header />
    <div class="auto1200">
      <div class="slogen">
        <p class="time">活动时间：11.01-11.11</p>
        <div class="tag">DDE决策、四维战法、董秘爆料、热点轮动、大数据掘金、涨停分析</div>
        <div class="text">双11活动期间(11月1日至11月11日)，购买大智慧财富版、专业版、大智慧365一年卡，
  享6折优惠，最高立省￥3920元！机会难得，立即抢购。</div>
      </div>
      <div class="list">
        <div class="item" v-for="product in productList" :key="product.key">
          <h3>{{product.name}}</h3>
          <p class="curPrice">活动价<span><em>￥</em>{{product.curPrice}}</span></p>
          <del class="oldPrice">原价<span><em>￥</em>{{product.oldPrice}}</span></del>
          <span class="button" @click="goUrl(product.key)"><em>立即购买</em></span>
        </div>
      </div>
      <div class="content">
        <h3>股知道，价值投资利器</h3>
        <div class="img-box">
          <div class="img">
            <img src="@/assets/images/activity/double11/1/img1.png" alt="">
          </div>
        </div>
        <h3>机构热股，让机构帮你挖掘投资主线</h3>
        <div class="img-box">
          <div class="img">
            <img src="@/assets/images/activity/double11/1/img2.png" alt="">
          </div>
        </div>
        <h3>热点轮动，智能捕捉短线热门概念题材及龙头股的脉络</h3>
        <div class="img-box">
          <div class="img">
            <img src="@/assets/images/activity/double11/1/img3.png" alt="">
          </div>
        </div>
      </div>
      <div class="note">
        <p><em>温馨提示：</em><span>上述产品的双年卡、月卡、季卡，及大智慧策略投资终端、大智慧港股通专业版产品，不参与本次双十一优惠活动</span></p>
        <p>案例仅用于客观数据展示，不构成投资建议，据此操作风险自担。</p>
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  data() {
    return {
      productList: [
        {
          key: 126,
          name: '财富版',
          curPrice: 5880,
          oldPrice: 9800
        },
        {
          key: 73,
          name: '专业版',
          curPrice: 1608,
          oldPrice: 2680
        },
        {
          key: 116,
          name: '365版',
          curPrice: 598,
          oldPrice: 998
        }
      ]
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  methods: {
    goUrl (key) {
      let routerDate;
      if (this.token) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key}})
      }
      let {href} = routerDate
      window.open(href, "_blank")
    }
  },
  components: {
    AppHeader,
  }
}
</script>

<style lang="scss" scoped>
.double11-wrap{
  background: url(../../assets/images/activity/double11/1/bg1.jpg) no-repeat center 100px,
  url(../../assets/images/activity/double11/1/bg2.jpg) no-repeat center 900px,
  url(../../assets/images/activity/double11/1/bg3.jpg) no-repeat center 1700px,
  url(../../assets/images/activity/double11/1/bg4.jpg) no-repeat center 2500px,
  url(../../assets/images/activity/double11/1/bg5.jpg) no-repeat center 3500px #fe7971;
  .auto1200{width: 1200px;margin: 0 auto;}
  .slogen{
    padding-top: 490px;
    .time{
      text-shadow: 0 5px 8px rgba($color: #ff8878, $alpha: 0.5);
      text-align: center;
      font-size: 24px;
      color: #fff;
    }
    .tag{
      background: url(../../assets/images/activity/double11/1/tag-bg.png) no-repeat;
      width: 1200px;
      height: 58px;
      font-size: 22px;
      color: #ffe793;
      line-height: 46px;
      text-align: center;
      margin: 20px 0 38px;
    }
    .text{
      font-size: 30px;
      color: #fff;
      line-height: 38px;
      padding-left: 60px;
      background: url(../../assets/images/activity/double11/1/star.png) no-repeat 0 -5px;
    }
  }
  .list{
    margin: 45px 0 40px;
    padding-bottom: 20px;
    overflow: hidden;
    .item{
      padding: 50px 0 10px;
      width: 350px;
      background-image: linear-gradient(to bottom, #ef5697, #f73e5d);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ef5697', endColorstr='#f73e5d',GradientType=0 ); // ie9
      text-align: center;
      border-radius: 30px;
      box-shadow: 0 10px 10px rgba($color: #fe4062, $alpha: 0.5);
      float: left;
      +.item{
        margin-left: 75px;
      }
      h3{
        font-size: 80px;
        color: #fff;
        line-height: 1;
      }
      >p{
        line-height: 1;
        em{
          margin: 0 8px;
        }
      }
      .curPrice{
        font-size: 40px;
        color: #fff;
        margin: 45px 0 20px;
      }
      .oldPrice{
        font-size: 30px;
        color: #ffdf81;
      }
      .button{
        background-image: linear-gradient(to bottom, #ffee8f, #ffab50);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffee8f', endColorstr='#ffab50',GradientType=0 ); // ie9
        width: 330px;
        display: block;
        margin: 75px auto 0;
        border-radius: 40px;
        @include fc(48px, #ec2e4f);
        cursor: pointer;
        display: table;
        height: 80px;
        >em{
          display: table-cell;
          vertical-align: middle;
        }
      }
    }
  }
  .content{
    h3{
      text-align: center;
      text-shadow: 0 5px 8px rgba($color: #ed1d3f, $alpha: 0.5);
      font-size: 36px;
      color: #fff;
      &:before, &:after{
        content: '';
        display: inline-block;
        background: url(../../assets/images/activity/double11/1/left.png) no-repeat;
        width: 49px;
        height: 36px;
        vertical-align: middle;
        margin-top: 3px;
      }
      &:before{
        background: url(../../assets/images/activity/double11/1/left.png) no-repeat;
        margin-right: 30px;
      }
      &:after{
        background: url(../../assets/images/activity/double11/1/right.png) no-repeat;
        margin-left: 30px;
      }
    }
    .img-box{
      background-image: linear-gradient(to bottom, #febd76, #ff677c);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#febd76', endColorstr='#ff677c',GradientType=0 ); // ie9
      box-shadow: 0 8px 5px rgba($color: #ed1d3f, $alpha: 0.5);
      padding: 16px;
      margin: 40px 0;
    }
    .img{
      background: #fff;
      padding: 28px 0;
      img{
        display: block;
        margin: 0 auto;
     }
    }
  }
  .note{
    padding:0 40px 70px;
    p{
      font-size: 24px;
      color: #fff;
      line-height: 36px;
      margin-bottom: 5px;
      >em{
        float: left;
        height: 60px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/DoubelEleven1.vue